import { FeatureName } from '@/models/role.models';
import ListAuditHistoryPage from '../AuditHistory/pages/ListAuditHistoryPage';
import EditCustomerPage from '../Customers/pages/EditCustomerPage';
import ListCustomerPage from '../Customers/pages/ListCustomersPage';
import { CompareDevicePage } from '../Devices/pages/CompareDevicesPage';
import DeviceMediaPage from '../Devices/pages/DeviceMediaPage';
import EditDevicePage from '../Devices/pages/EditDevicePage';
import ListDevicePage from '../Devices/pages/ListDevicePage';
import EditSitePage from '../Site/pages/EditSitePage';
import ListSitePage from '../Site/pages/ListSitesPage';

export interface AppRoute {
  path: string;
  element: React.ReactNode;
  breadcrumb: string;
  feature: FeatureName;
}

export const allRoutes: AppRoute[] = [
  {
    path: '/devices',
    breadcrumb: 'Devices',
    element: <ListDevicePage />,
    feature: FeatureName.VIEW_LIST_DEVICES_PAGE,
  },
  {
    path: '/devices/compare',
    breadcrumb: 'Compare Devices',
    element: <CompareDevicePage />,
    feature: FeatureName.VIEW_DEVICE_COMPARE_PAGE,
  },
  {
    path: '/devices/:id',
    breadcrumb: 'Edit Device',
    element: <EditDevicePage />,
    feature: FeatureName.VIEW_LIST_DEVICES_PAGE,
  },
  {
    path: '/devices/:id/media',
    breadcrumb: 'Device Media',
    element: <DeviceMediaPage />,
    feature: FeatureName.VIEW_LIST_DEVICES_PAGE,
  },
  {
    path: '/sites',
    breadcrumb: 'Sites',
    element: <ListSitePage />,
    feature: FeatureName.VIEW_LIST_SITES_PAGE,
  },

  {
    path: '/sites/:id',
    breadcrumb: 'Edit Site',
    element: <EditSitePage />,
    feature: FeatureName.VIEW_EDIT_SITE_PAGE,
  },
  {
    path: '/customers',
    breadcrumb: 'Customers',
    element: <ListCustomerPage />,
    feature: FeatureName.VIEW_LIST_CUSTOMERS_PAGE,
  },
  {
    path: '/customers/:id',
    breadcrumb: 'Edit Customer',
    element: <EditCustomerPage />,
    feature: FeatureName.VIEW_EDIT_CUSTOMER_PAGE,
  },
  {
    path: 'audits',
    breadcrumb: 'Audit History',
    element: <ListAuditHistoryPage />,
    feature: FeatureName.VIEW_AUDIT_HISTORY,
  },
];
